import type { FormikErrors, FormikTouched } from "formik";
import type { WorkingHoursWeekValueDto } from "@me-pos/schedule-modal";

export const getWorkingHoursFieldMeta = <FormValues extends object>(params: {
    fieldName: string;
    values: FormValues;
    errors: FormikErrors<FormValues>;
    touched: FormikTouched<FormValues>;
}) => {
    const { fieldName, values, errors, touched } = params;

    const value = values[fieldName as keyof FormValues] as WorkingHoursWeekValueDto | null;

    const rawError = touched[fieldName as keyof FormValues] ? errors[fieldName as keyof FormValues] : undefined;

    return {
        value,
        errorText: rawError ? String(rawError) : "",
        isInvalid: Boolean(rawError),
    };
};
